const moveElementPos = (array, fromIndex, to) => {
  let numberOfDeletedItems = 1;
  const elt = array.splice(fromIndex, numberOfDeletedItems)[0];
  numberOfDeletedItems = 0;
  array.splice(to, numberOfDeletedItems, elt);
  return array;
};

export default moveElementPos;
